import { Form, Input } from "antd"
import { FormikProps } from "formik"
import React, { FC, memo } from "react"
import { RegistrationPanelValidationType } from "./RegistrationPanelValidationSchema"
import { createInputHelpers } from "../../helpers/createInputHelpers"
import { QueryLazyOptions } from "@apollo/client"
import { Exact } from "../../generated/graphql"
import { useTranslation } from "react-i18next"

type RegistrationPanelStep0Props = {
    formikProps: FormikProps<RegistrationPanelValidationType>
    checkIfExists: (field: string, value: string, shouldValidate: boolean) => void
    checkUniquess: (
        options?:
            | QueryLazyOptions<
                  Exact<{
                      email: string
                  }>
              >
            | undefined
    ) => void
    thirdPartyUserFields: any
}

const RegistrationPanelStep0: FC<RegistrationPanelStep0Props> = ({ formikProps, checkIfExists, checkUniquess, thirdPartyUserFields }) => {
    const { t, i18n } = useTranslation()
    const values = formikProps.values
    const { handleBlur, handleTextInputChange, validateStatus, help } = createInputHelpers(formikProps)
    return (
        <>
            <Form.Item colon={false} validateStatus={validateStatus("username")} help={help("username")} required validateTrigger='blur'>
                <Input
                    data-testid='registration-email-input'
                    value={values.username}
                    placeholder={t("registration.userName", "Benutzername (e-mail)")}
                    name='username'
                    type='email'
                    onChange={handleTextInputChange("username")}
                    onBlur={(event) => checkIfExists("username", event.target.value, true)}
                    onKeyUp={(event) => {
                        if (event.key === "Enter") {
                            console.log("!!! event.key: ", event.key)
                            checkUniquess({
                                variables: { email: values.username },
                            })
                        }
                    }}
                    autoFocus
                />
                <Input name='email' type='hidden' value={values.username} onChange={handleTextInputChange("email")} />
            </Form.Item>
            <Form.Item colon={false} validateStatus={validateStatus("password")} help={help("password")} required>
                <Input
                    data-testid='registration-password-input'
                    value={values.password}
                    placeholder={t("registration.password", "Passwort")}
                    name='password'
                    type='password'
                    onChange={handleTextInputChange("password")}
                    status={validateStatus(thirdPartyUserFields)}
                    onBlur={handleBlur("password")}
                    onFocus={(event) => checkIfExists("username", values.username, true)}
                    //
                />
            </Form.Item>
            <Form.Item colon={false} validateStatus={validateStatus("passwordConfirmation")} help={help("passwordConfirmation")} required>
                <Input
                    data-testid='registration-password-confirm-input'
                    value={values.passwordConfirmation}
                    placeholder={t("registration.confirmPassword", "Passwort bestätigen")}
                    name='passwordConfirmation'
                    type='password'
                    onChange={handleTextInputChange("passwordConfirmation")}
                    onBlur={handleBlur("passwordConfirmation")}
                    onFocus={(event) => checkIfExists("username", values.username, true)}
                />
            </Form.Item>
            {/* </LayoutForm> */}
        </>
    )
}

export default memo(RegistrationPanelStep0)
